<div
  class="mb-4 mt-3 grid form-builder-container"
  [ngClass]="showPreview ? 'grid-cols-2 gap-4' : 'grid-cols-1'"
>
  <mat-card
    class="p-3! mb-3! col-span-2 sticky! top-0! z-1000! shadow-md!"
    appearance="raised"
  >
    <div
      class="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center"
    >
      <button
        (click)="addSection()"
        type="button"
        matButton="outlined"
        class="w-full sm:w-auto text-black"
        [attr.aria-label]="'Aggiungi sezione'"
        matTooltip="Aggiungi sezione"
      >
        <mat-icon class="text-black">post_add</mat-icon>
        <span class="text-black">Aggiungi sezione</span>
      </button>
      <div class="flex flex-col gap-2 sm:flex-row sm:ml-auto">
        <button
          (click)="showPreviewClicked()"
          type="button"
          matButton="tonal"
          class="w-full sm:w-auto"
          matTooltip="Visualizza anteprima"
          [attr.aria-label]="
            showPreview ? 'Chiudi anteprima' : 'Visualizza anteprima'
          "
        >
          <mat-icon class="material-icons-outlined">{{
            showPreview ? 'visibility_off' : 'visibility'
          }}</mat-icon>
          {{ showPreview ? 'Chiudi anteprima' : 'Visualizza anteprima' }}
        </button>
        <button
          type="button"
          matButton="filled"
          class="w-full sm:w-auto"
          matTooltip="Salva form"
          [attr.aria-label]="'Salva nuovo form'"
          [disabled]="!formGroup.valid"
          (click)="loadOnClickSave()"
        >
          <mat-icon class="material-icons-outlined">save</mat-icon>
          Salva
        </button>
      </div>
    </div>
  </mat-card>
  <div
    [ngClass]="showPreview ? 'col-span-1' : 'col-span-2'"
    cdkDropList
    (cdkDropListDropped)="onSectionDropped($event)"
    [cdkDropListDisabled]="isSectionDragDisabled"
  >
    <div>
      <mat-card class="mb-2 px-3 pb-3" appearance="raised">
        <mat-card-title
          ><h2 class="text-xl mb-1 font-medium">Intestazione Form</h2>
          <hr />
        </mat-card-title>
        <mat-card-content class="p-0!">
          <div>
            <siat-input-field
              matCardTitle
              [formGroup]="formGroup"
              controlName="title"
              appearance="outline"
              [id]="'title'"
              [placeholder]="'Inserisci il titolo del form'"
              [label]="'Titolo form'"
              type="text"
              class="w-full"
            ></siat-input-field>
          </div>
          <div class="mt-3">
            <siat-input-field
              matCardSubtitle
              [formGroup]="formGroup"
              [id]="'description'"
              controlName="description"
              [placeholder]="
                formGroup.value.description ||
                'Inserisci la descrizione del form'
              "
              [label]="'Descrizione'"
              type="text"
              appearance="outline"
              class="w-full"
            ></siat-input-field>
          </div>
        </mat-card-content>
      </mat-card>
      @for (
        section of sections.controls;
        track trackByFn($index);
        let i = $index
      ) {
        <mat-card
          cdkDrag
          [cdkDragData]="section"
          (click)="selectSection(i)"
          (keyup)="selectSection(i)"
          class="mb-2 px-3 pb-3"
          appearance="raised"
          [class.selected]="selectedSectionIndex === i"
        >
          <mat-card-header class="mt-2">
            <div cdkDragHandle class="mx-auto text-center">
              <mat-icon
                class="cursor-not-allowed"
                [ngClass]="{
                  'cursor-move! disabled': !isSectionDragDisabled,
                }"
                >drag_indicator</mat-icon
              >
            </div>
          </mat-card-header>

          <siat-form-section-builder
            [sectionIndex]="i + 1"
            [sectionId]="section?.value?.id"
            [sectionForm]="asFormGroup(section)"
            (deleteSection)="deleteSection(section?.value?.id)"
            (dragFieldsToggle)="updateDragFieldsEnabled(i, $event)"
          />
        </mat-card>
      }
    </div>
  </div>

  @if (showPreview) {
    <div class="col-span-1">
      <mat-card class="p-3" appearance="raised">
        <mat-card-title
          ><h2 class="text-xl mb-1 mt-1 font-medium">Anteprima</h2>
          <hr />
        </mat-card-title>
        <mat-card-content class="p-0!">
          <siat-preview-container
            [dynamicFormDto]="dynamicFormDTO"
          ></siat-preview-container>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
